// Kullanıcı tipi
export interface User {
  id: string;
  name: string;
  displayName: string;
}

// Oyun veri tipi
export interface Game {
  id: string;
  name: string;
  currentLevel: number;
  maxLevel?: number;
  description: string;
  lastPlayed?: Date;
  notes?: string;
  userId: string; // Hangi kullanıcıya ait olduğunu belirten alan
}

// Oyun kategorisi tipi
export interface GameCategory {
  id: string;
  name: string;
  games: Game[];
}

// Kullanıcı listesi
export const users: User[] = [
  { id: 'ali-hamdi', name: 'ali-hamdi', displayName: 'Ali Hamdi' },
  { id: 'mehmet-tarik', name: 'mehmet-tarik', displayName: 'Mehmet Tarık' },
  { id: 'sarwar', name: 'sarwar', displayName: 'Sarwar' },
  { id: 'cetin', name: 'cetin', displayName: 'Çetin' },
  { id: 'ender', name: 'ender', displayName: 'Ender' }
];

// Varsayılan oyun şablonu listesi (16 oyun)
export const gameTemplates: Omit<Game, 'id' | 'userId'>[] = [
  { name: 'Prism', currentLevel: 1, description: 'Prism', maxLevel: 100 },
  { name: 'Mind Twist', currentLevel: 1, description: 'Mind Twist', maxLevel: 100 },
  { name: 'Block Blast', currentLevel: 1, description: 'Block Blast', maxLevel: 100 },
  { name: 'Cargo Dash', currentLevel: 1, description: 'Cargo Dash', maxLevel: 100 },
  { name: 'Moo', currentLevel: 1, description: 'Moo', maxLevel: 100 },
  { name: 'Candy Short', currentLevel: 1, description: 'Candy Short', maxLevel: 100 },
  { name: 'Boomles', currentLevel: 1, description: 'Boomles', maxLevel: 100 },
  { name: 'Memory Box', currentLevel: 1, description: 'Memory Box', maxLevel: 100 },
  { name: 'Word Block', currentLevel: 1, description: 'Word Block', maxLevel: 100 },
  { name: 'React', currentLevel: 1, description: 'React', maxLevel: 100 },
  { name: 'Knife', currentLevel: 1, description: 'Knife', maxLevel: 100 },
  { name: 'Peak Drop', currentLevel: 1, description: 'Peak Drop', maxLevel: 100 },
  { name: 'Wordle Classic', currentLevel: 1, description: 'Wordle Classic', maxLevel: 100 },
  { name: 'Wordle Plus', currentLevel: 1, description: 'Wordle Plus', maxLevel: 100 },
  { name: 'Linguix', currentLevel: 1, description: 'Linguix', maxLevel: 100 },
  { name: 'Sense Hunt', currentLevel: 1, description: 'Sense Hunt', maxLevel: 100 }
];
